import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSort = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g id="Custom/sort">
      <path
        id="Vector"
        d="M4.19536 2.86196C4.32038 2.73698 4.48992 2.66677 4.66669 2.66677C4.84347 2.66677 5.01301 2.73698 5.13803 2.86196L7.80469 5.52863C7.92613 5.65436 7.99333 5.82276 7.99181 5.99756C7.99029 6.17236 7.92018 6.33957 7.79657 6.46317C7.67297 6.58678 7.50576 6.65689 7.33096 6.65841C7.15616 6.65993 6.98776 6.59273 6.86203 6.47129L5.33336 4.94263V12.6666C5.33336 12.8434 5.26312 13.013 5.1381 13.138C5.01307 13.2631 4.8435 13.3333 4.66669 13.3333C4.48988 13.3333 4.32031 13.2631 4.19529 13.138C4.07027 13.013 4.00003 12.8434 4.00003 12.6666V4.94263L2.47136 6.47129C2.34563 6.59273 2.17722 6.65993 2.00243 6.65841C1.82763 6.65689 1.66042 6.58678 1.53681 6.46317C1.41321 6.33957 1.3431 6.17236 1.34158 5.99756C1.34006 5.82276 1.40726 5.65436 1.52869 5.52863L4.19536 2.86196ZM10.6667 11.0573V3.33329C10.6667 3.15648 10.7369 2.98691 10.862 2.86189C10.987 2.73686 11.1565 2.66663 11.3334 2.66663C11.5102 2.66663 11.6797 2.73686 11.8048 2.86189C11.9298 2.98691 12 3.15648 12 3.33329V11.0573L13.5287 9.52863C13.6544 9.40719 13.8228 9.33999 13.9976 9.34151C14.1724 9.34303 14.3396 9.41314 14.4632 9.53675C14.5868 9.66035 14.657 9.82756 14.6585 10.0024C14.66 10.1772 14.5928 10.3456 14.4714 10.4713L11.8047 13.138C11.6797 13.2629 11.5101 13.3332 11.3334 13.3332C11.1566 13.3332 10.987 13.2629 10.862 13.138L8.19536 10.4713C8.07392 10.3456 8.00673 10.1772 8.00824 10.0024C8.00976 9.82756 8.07988 9.66035 8.20348 9.53675C8.32709 9.41314 8.4943 9.34303 8.66909 9.34151C8.84389 9.33999 9.01229 9.40719 9.13803 9.52863L10.6667 11.0573Z"
      />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgSort)
const IconSvgSort = createIcon(ForwardRef, 'SvgSort')
export default IconSvgSort
